module.exports = __webpack_public_path__ + "images/c6257d5.png";